/**
 * Form Container
 */
import { Component, registerComponent } from "js/component.js";
const componentName = "form-container-meteor";

class FormContainer extends Component {
    /**
     * Component Setup
     */
    // Elements
    elements = {
        form: this.element.querySelector(`form`),
        defaultIndustryOptions: this.element.querySelector(
            ".px-default-options--industry",
        ),
        defaultCountryOptions: this.element.querySelector(
            ".px-default-options--country",
        ),
        defaultHelpOptions: this.element.querySelector(
            ".px-default-options--help",
        ),
        industrySelect: this.element.querySelector('select[name="industry1"]'),
        countrySelect: this.element.querySelector('select[name="country"]'),
        stateSelect: this.element.querySelector('select[name="stateProv"]'),
        helpSelect: this.element.querySelector(
            'select[name="QualifyingQuestions"]',
        ),
        submitButton: this.element.querySelector('button[type="submit"]'),
        canadiaOptIn: this.element.querySelector(
            'input[name="canadianOptIn1"]',
        ),
        gdprConsent: this.element.querySelector('input[name="gDPRConsent1"]'),
    };

    // Util & State
    state = {
        theme: this.elements.form.getAttribute("data-theme"),
        digitalData: window.digitalData || [],
        formName: this.elements.form.getAttribute("data-name") || "default",
        formId: this.elements.form.getAttribute("data-id") || "default",
        formTitle: this.elements.form.getAttribute("data-title") || "default",
        formType: this.elements.form.getAttribute("data-type") || "default",
        formAction: this.elements.form.getAttribute("action"),
        redirectPage: this.elements.form.getAttribute("data-redirect"),
        stateInputType: "select",
        siteCountry:
            document.documentElement.lang.split("-")[1].toLowerCase() || "us",
    };

    euCountries = [
        "Albania",
        "Åland Islands",
        "Algeria",
        "Andorra",
        "Angola",
        "Armenia",
        "Austria",
        "Bahrain",
        "Belarus",
        "Belgium",
        "Benin",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cameroon",
        "Cape Verde",
        "Central African Republic",
        "Chad",
        "Congo",
        "Congo, Democratic Republic",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Egypt",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "European Union",
        "Faroe Islands",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Guinea",
        "Guinea-Bissau",
        "Guernsey",
        "Hungary",
        "Iceland",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Ivory Coast",
        "Jersey",
        "Jordan",
        "Kenya",
        "Kuwait",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "North Macedonia",
        "Madagascar",
        "Malawi",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Moldova",
        "Monaco",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Netherlands",
        "Netherlands Antilles",
        "Niger",
        "Nigeria",
        "Norway",
        "Oman",
        "Palestine",
        "Poland",
        "Portugal",
        "Qatar",
        "Réunion",
        "Romania",
        "Russia",
        "Rwanda",
        "San Marino",
        "São Tomé and Príncipe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Serbia and Montenegro",
        "Seychelles",
        "Sierra Leone",
        "Slovakia",
        "Slovenia",
        "Somalia",
        "South Africa",
        "Spain",
        "Saint Helena",
        "South Sudan",
        "Sudan",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Tanzania",
        "Togo",
        "Tunisia",
        "Turkey",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "Vatican",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
        "Azerbaijan",
        "Kazakhstan",
        "Uzbekistan",
        "Kosovo",
    ];

    countryToStatesMap = {
        "United States": [
            { name: "Alabama", code: "AL" },
            { name: "Alaska", code: "AK" },
            { name: "American Samoa", code: "AS" },
            { name: "Arizona", code: "AZ" },
            { name: "Arkansas", code: "AR" },
            { name: "California", code: "CA" },
            { name: "Colorado", code: "CO" },
            { name: "Connecticut", code: "CT" },
            { name: "Delaware", code: "DE" },
            { name: "District Of Columbia", code: "DC" },
            { name: "Florida", code: "FL" },
            { name: "Georgia", code: "GA" },
            { name: "Guam", code: "GU" },
            { name: "Hawaii", code: "HI" },
            { name: "Idaho", code: "ID" },
            { name: "Illinois", code: "IL" },
            { name: "Indiana", code: "IN" },
            { name: "Iowa", code: "IA" },
            { name: "Kansas", code: "KS" },
            { name: "Kentucky", code: "KY" },
            { name: "Louisiana", code: "LA" },
            { name: "Maine", code: "ME" },
            { name: "Maryland", code: "MD" },
            { name: "Massachusetts", code: "MA" },
            { name: "Michigan", code: "MI" },
            { name: "Minnesota", code: "MN" },
            { name: "Mississippi", code: "MS" },
            { name: "Missouri", code: "MO" },
            { name: "Montana", code: "MT" },
            { name: "Nebraska", code: "NE" },
            { name: "Nevada", code: "NV" },
            { name: "New Hampshire", code: "NH" },
            { name: "New Jersey", code: "NJ" },
            { name: "New Mexico", code: "NM" },
            { name: "New York", code: "NY" },
            { name: "North Carolina", code: "NC" },
            { name: "North Dakota", code: "ND" },
            { name: "Northern Mariana Islands", code: "MP" },
            { name: "Ohio", code: "OH" },
            { name: "Oklahoma", code: "OK" },
            { name: "Oregon", code: "OR" },
            { name: "Pennsylvania", code: "PA" },
            { name: "Puerto Rico", code: "PR" },
            { name: "Rhode Island", code: "RI" },
            { name: "South Carolina", code: "SC" },
            { name: "South Dakota", code: "SD" },
            { name: "Tennessee", code: "TN" },
            { name: "Texas", code: "TX" },
            { name: "Utah", code: "UT" },
            { name: "Vermont", code: "VT" },
            { name: "Virgin Islands", code: "VI" },
            { name: "Virginia", code: "VA" },
            { name: "Washington", code: "WA" },
            { name: "West Virginia", code: "WV" },
            { name: "Wisconsin", code: "WI" },
            { name: "Wyoming", code: "WY" },
        ],
        Canada: [
            { name: "Alberta", code: "AB" },
            { name: "British Columbia", code: "BC" },
            { name: "Manitoba", code: "MB" },
            { name: "New Brunswick", code: "NB" },
            { name: "Newfoundland and Labrador", code: "NL" },
            { name: "Northwest Territories", code: "NT" },
            { name: "Nova Scotia", code: "NS" },
            { name: "Nunavut", code: "NU" },
            { name: "Ontario", code: "ON" },
            { name: "Prince Edward Island", code: "PE" },
            { name: "Quebec", code: "QC" },
            { name: "Saskatchewan", code: "SK" },
            { name: "Yukon", code: "YT" },
        ],
        Australia: [
            { name: "Australian Capital Territory", code: "ACT" },
            { name: "New South Wales", code: "NSW" },
            { name: "Northern Territory", code: "NT" },
            { name: "Queensland", code: "QLD" },
            { name: "South Australia", code: "SA" },
            { name: "Tasmania", code: "TAS" },
            { name: "Victoria", code: "VIC" },
            { name: "Western Australia", code: "WA" },
        ],
        "New Zealand": [
            { name: "Auckland", code: "AUK" },
            { name: "Bay of Plenty", code: "BOP" },
            { name: "Canterbury", code: "CAN" },
            { name: "Chatham Islands Territory", code: "CIT" },
            { name: "Gisborne", code: "GIS" },
            { name: "Hawke's Bay", code: "HKB" },
            { name: "Marlborough", code: "MBH" },
            { name: "Manawatu-Wanganui", code: "MWT" },
            { name: "Nelson", code: "NSN" },
            { name: "Northland", code: "NTL" },
            { name: "Otago", code: "OTA" },
            { name: "Southland", code: "STL" },
            { name: "Tasman", code: "TAS" },
            { name: "Taranaki", code: "TKI" },
            { name: "Wellington", code: "WGN" },
            { name: "Waikato", code: "WKO" },
            { name: "West Coast", code: "WTC" },
        ],
        China: [
            { name: "Anhui", code: "AH" },
            { name: "Beijing", code: "BJ" },
            { name: "Chongqing", code: "CQ" },
            { name: "Fujian", code: "FJ" },
            { name: "Gansu", code: "GS" },
            { name: "Guangdong", code: "GD" },
            { name: "Guangxi", code: "GX" },
            { name: "Guizhou", code: "GZ" },
            { name: "Hainan", code: "HI" },
            { name: "Hebei", code: "HE" },
            { name: "Heilongjiang", code: "HL" },
            { name: "Henan", code: "HA" },
            { name: "Hubei", code: "HB" },
            { name: "Hunan", code: "HN" },
            { name: "Inner Mongolia", code: "NM" },
            { name: "Jiangsu", code: "JS" },
            { name: "Jiangxi", code: "JX" },
            { name: "Jilin", code: "JL" },
            { name: "Liaoning", code: "LN" },
            { name: "Ningxia", code: "NX" },
            { name: "Qinghai", code: "QH" },
            { name: "Shaanxi", code: "SN" },
            { name: "Shandong", code: "SD" },
            { name: "Shanghai", code: "SH" },
            { name: "Shanxi", code: "SX" },
            { name: "Sichuan", code: "SC" },
            { name: "Tianjin", code: "TJ" },
            { name: "Tibet", code: "XZ" },
            { name: "Xinjiang", code: "XJ" },
            { name: "Yunnan", code: "YN" },
            { name: "Zhejiang", code: "ZJ" },
        ],
        India: [
            { name: "Andaman and Nicobar Islands", code: "AN" },
            { name: "Andhra Pradesh", code: "AP" },
            { name: "Arunachal Pradesh", code: "AR" },
            { name: "Assam", code: "AS" },
            { name: "Bihar", code: "BR" },
            { name: "Chandigarh", code: "CH" },
            { name: "Chhattisgarh", code: "CG" },
            { name: "Dadra and Nagar Haveli and Daman and Diu", code: "DN" },
            { name: "Delhi", code: "DL" },
            { name: "Goa", code: "GA" },
            { name: "Gujarat", code: "GJ" },
            { name: "Haryana", code: "HR" },
            { name: "Himachal Pradesh", code: "HP" },
            { name: "Jammu and Kashmir", code: "JK" },
            { name: "Jharkhand", code: "JH" },
            { name: "Karnataka", code: "KA" },
            { name: "Kerala", code: "KL" },
            { name: "Ladakh", code: "LA" },
            { name: "Lakshadweep", code: "LD" },
            { name: "Madhya Pradesh", code: "MP" },
            { name: "Maharashtra", code: "MH" },
            { name: "Manipur", code: "MN" },
            { name: "Meghalaya", code: "ML" },
            { name: "Mizoram", code: "MZ" },
            { name: "Nagaland", code: "NL" },
            { name: "Odisha", code: "OR" },
            { name: "Puducherry", code: "PY" },
            { name: "Punjab", code: "PB" },
            { name: "Rajasthan", code: "RJ" },
            { name: "Sikkim", code: "SK" },
            { name: "Tamil Nadu", code: "TN" },
            { name: "Telangana", code: "TG" },
            { name: "Tripura", code: "TR" },
            { name: "Uttar Pradesh", code: "UP" },
            { name: "Uttarakhand", code: "UK" },
            { name: "West Bengal", code: "WB" },
        ],
        Argentina: [
            { name: "Buenos Aires", code: "Buenos Aires" },
            { name: "Catamarca", code: "Catamarca" },
            { name: "Chaco", code: "Chaco" },
            { name: "Chubut", code: "Chubut" },
            { name: "Corrientes", code: "Corrientes" },
            {
                name: "Ciudad Autónoma de Buenos Aires",
                code: "Ciudad Autónoma de Buenos Aires",
            },
            { name: "Córdoba", code: "Córdoba" },
            { name: "Entre Ríos", code: "Entre Ríos" },
            { name: "Formosa", code: "Formosa" },
            { name: "Jujuy", code: "Jujuy" },
            { name: "La Pampa", code: "La Pampa" },
            { name: "La Rioja", code: "La Rioja" },
            { name: "Mendoza", code: "Mendoza" },
            { name: "Misiones", code: "Misiones" },
            { name: "Neuquén", code: "Neuquén" },
            { name: "Salta", code: "Salta" },
            { name: "San Juan", code: "San Juan" },
            { name: "San Luis", code: "San Luis" },
            { name: "Santa Cruz", code: "Santa Cruz" },
            { name: "Santa Fe", code: "Santa Fe" },
            { name: "Santiago del Estero", code: "Santiago del Estero" },
            { name: "Tierra del Fuego", code: "Tierra del Fuego" },
            { name: "Tucumán", code: "Tucumán" },
        ],
        Bolivia: [
            { name: "Chuquisaca", code: "Chuquisaca" },
            { name: "Cochabamba", code: "Cochabamba" },
            { name: "El Beni", code: "El Beni" },
            { name: "La Paz", code: "La Paz" },
            { name: "Oruro", code: "Oruro" },
            { name: "Pando", code: "Pando" },
            { name: "Potosí", code: "Potosí" },
            { name: "Santa Cruz", code: "Santa Cruz" },
            { name: "Tarija", code: "Tarija" },
        ],
        Brazil: [
            { name: "Acre", code: "AC" },
            { name: "Alagoas", code: "AL" },
            { name: "Amapá", code: "AP" },
            { name: "Amazonas", code: "AM" },
            { name: "Bahia", code: "BA" },
            { name: "Ceará", code: "CE" },
            { name: "Distrito Federal", code: "DF" },
            { name: "Espírito Santo", code: "ES" },
            { name: "Goias", code: "GO" },
            { name: "Maranhão", code: "MA" },
            { name: "Mato Grosso", code: "MT" },
            { name: "Mato Grosso do Sul", code: "MS" },
            { name: "Minas Gerais", code: "MG" },
            { name: "Pará", code: "PA" },
            { name: "Paraíba", code: "PB" },
            { name: "Paraná", code: "PR" },
            { name: "Pernambuco", code: "PE" },
            { name: "Piauí", code: "PI" },
            { name: "Rio de Janeiro", code: "RJ" },
            { name: "Rio Grande do Norte", code: "RN" },
            { name: "Rio Grande do Sul", code: "RS" },
            { name: "Rondônia", code: "RO" },
            { name: "Roraima", code: "RR" },
            { name: "Santa Catarina", code: "SC" },
            { name: "Sao Paulo", code: "SP" },
            { name: "Sergipe", code: "SE" },
            { name: "Tocantins", code: "TO" },
        ],
        Chile: [
            { name: "Aisén del General Carlos Ibáñez del Campo", code: "AI" },
            { name: "Antofagasta", code: "AN" },
            { name: "Araucanía", code: "AR" },
            { name: "Arica y Parinacota", code: "AP" },
            { name: "Atacama", code: "AT" },
            { name: "Bío-Bío", code: "BI" },
            { name: "Coquimbo", code: "CO" },
            { name: "Libertador General Bernardo O'Higgins", code: "LI" },
            { name: "Los Lagos", code: "LL" },
            { name: "Los Ríos", code: "LR" },
            { name: "Magallanes", code: "MA" },
            { name: "Maule", code: "ML" },
            { name: "Region Metropolitana de Santiago", code: "RM" },
            { name: "Tarapaca", code: "TA" },
            { name: "Valparaíso", code: "VS" },
        ],
        Colombia: [
            { name: "Amazonas", code: "AMA" },
            { name: "Antioquia", code: "ANT" },
            { name: "Arauca", code: "ARA" },
            { name: "Atlantico", code: "ATL" },
            { name: "Bolivar", code: "BOL" },
            { name: "Boyacá", code: "BOY" },
            { name: "Caldas", code: "CAL" },
            { name: "Caquetá", code: "CAQ" },
            { name: "Casanare", code: "CAS" },
            { name: "Cauca", code: "CAU" },
            { name: "Cesar", code: "CES" },
            { name: "Chocó", code: "CHO" },
            { name: "Córdoba", code: "COR" },
            { name: "Cundinamarca", code: "CUN" },
            { name: "Distrito Capital de Bogotá", code: "DC" },
            { name: "Guainía", code: "GUA" },
            { name: "Guaviare", code: "GUV" },
            { name: "Huila", code: "HUI" },
            { name: "La Guajira", code: "LAG" },
            { name: "Magdalena", code: "MAG" },
            { name: "Meta", code: "MET" },
            { name: "Nariño", code: "NAR" },
            { name: "Norte de Santander", code: "NSA" },
            { name: "Putumayo", code: "PUT" },
            { name: "Quindio", code: "QUI" },
            { name: "Risaralda", code: "RIS" },
            { name: "San Andres y Providencia", code: "SAP" },
            { name: "Santander", code: "SAN" },
            { name: "Sucre", code: "SUC" },
            { name: "Tolima", code: "TOL" },
            { name: "Valle del Cauca", code: "VAC" },
            { name: "Vaupés", code: "VAU" },
            { name: "Vichada", code: "VID" },
        ],
        "Costa Rica": [
            { name: "Alajuela", code: "Alajuela" },
            { name: "Cartago", code: "Cartago" },
            { name: "Guanacaste", code: "Guanacaste" },
            { name: "Heredia", code: "Heredia" },
            { name: "Limon", code: "Limon" },
            { name: "Puntarenas", code: "Puntarenas" },
            { name: "San Jose", code: "San Jose" },
        ],
        Ecuador: [
            { name: "Azuay", code: "Azuay" },
            { name: "Bolívar", code: "Bolívar" },
            { name: "Cañar", code: "Cañar" },
            { name: "Carchi", code: "Carchi" },
            { name: "Chimborazo", code: "Chimborazo" },
            { name: "Cotopaxi", code: "Cotopaxi" },
            { name: "El Oro", code: "El Oro" },
            { name: "Esmeraldas", code: "Esmeraldas" },
            { name: "Galápagos", code: "Galápagos" },
            { name: "Guayas", code: "Guayas" },
            { name: "Imbabura", code: "Imbabura" },
            { name: "Loja", code: "Loja" },
            { name: "Los Ríos", code: "Los Ríos" },
            { name: "Manabí", code: "Manabí" },
            { name: "Morona-Santiago", code: "Morona-Santiago" },
            { name: "Napo", code: "Napo" },
            { name: "Orellana", code: "Orellana" },
            { name: "Pastaza", code: "Pastaza" },
            { name: "Pichincha", code: "Pichincha" },
            { name: "Santa Elena", code: "Santa Elena" },
            {
                name: "Santo Domingo de los Tsáchilas",
                code: "Santo Domingo de los Tsáchilas",
            },
            { name: "Sucumbíos", code: "Sucumbíos" },
            { name: "Tungurahua", code: "Tungurahua" },
            { name: "Zamora-Chinchipe", code: "Zamora-Chinchipe" },
        ],
        Guatemala: [
            { name: "Alta Verapaz", code: "AV" },
            { name: "Baja Verapaz", code: "BV" },
            { name: "Chimaltenango", code: "CM" },
            { name: "Chiquimula", code: "CQ" },
            { name: "El Progreso", code: "PR" },
            { name: "Escuintla", code: "ES" },
            { name: "Guatemala", code: "GU" },
            { name: "Huehuetenango", code: "HU" },
            { name: "Izabal", code: "IZ" },
            { name: "Jalapa", code: "JA" },
            { name: "Jutiapa", code: "JU" },
            { name: "Petén", code: "PE" },
            { name: "Quetzaltenango", code: "QZ" },
            { name: "Quiché", code: "QC" },
            { name: "Realhuleu", code: "RE" },
            { name: "Sacatepéquez", code: "SA" },
            { name: "San Marcos", code: "SM" },
            { name: "Santa Rosa", code: "SR" },
            { name: "Solalá", code: "SO" },
            { name: "Suchitepéquez", code: "SU" },
            { name: "Totonicapán", code: "TO" },
            { name: "Zacapa", code: "ZA" },
        ],
        Honduras: [
            { name: "Atlántida", code: "AT" },
            { name: "Choluteca", code: "CH" },
            { name: "Colón", code: "CL" },
            { name: "Comayagua", code: "CM" },
            { name: "Copán", code: "CP" },
            { name: "Cortés", code: "CR" },
            { name: "El Paraíso", code: "EP" },
            { name: "Francisco Morazán", code: "FM" },
            { name: "Gracias a Dios", code: "GD" },
            { name: "Intibucá", code: "IN" },
            { name: "Islas de la Bahía", code: "IB" },
            { name: "La Paz", code: "LP" },
            { name: "Lempira", code: "LE" },
            { name: "Ocotepeque", code: "OC" },
            { name: "Olancho", code: "OL" },
            { name: "Santa Bárbara", code: "SB" },
            { name: "Valle", code: "VA" },
            { name: "Yoro", code: "YO" },
        ],
        Mexico: [
            { name: "Aguascalientes", code: "AGU" },
            { name: "Baja California", code: "BCN" },
            { name: "Baja California Sur", code: "BCS" },
            { name: "Campeche", code: "CAM" },
            { name: "Chiapas", code: "CHP" },
            { name: "Chihuahua", code: "CHH" },
            { name: "Coahuila de Zaragoza", code: "COA" },
            { name: "Colima", code: "COL" },
            { name: "Distrito Federal", code: "DIF" },
            { name: "Durango", code: "DUR" },
            { name: "Guanajuato", code: "GUA" },
            { name: "Guerrero", code: "GRO" },
            { name: "Hidalgo", code: "HID" },
            { name: "Jalisco", code: "JAL" },
            { name: "México", code: "MEX" },
            { name: "Michoacán de Ocampo", code: "MIC" },
            { name: "Morelos", code: "MOR" },
            { name: "Nayarit", code: "NAY" },
            { name: "Nuevo León", code: "NLE" },
            { name: "Oaxaca", code: "OAX" },
            { name: "Puebla", code: "PUE" },
            { name: "Querétaro de Arteaga", code: "QUE" },
            { name: "Quintana Roo", code: "ROO" },
            { name: "San Luis Potosí", code: "SLP" },
            { name: "Sinaloa", code: "SIN" },
            { name: "Sonora", code: "SON" },
            { name: "Tabasco", code: "TAB" },
            { name: "Tamaulipas", code: "TAM" },
            { name: "Tlaxcala", code: "TLA" },
            { name: "Veracruz-Llave", code: "VER" },
            { name: "Yucatán", code: "YUC" },
            { name: "Zacatecas", code: "ZAC" },
        ],
        Nicaragua: [
            { name: "Atlántico Norte", code: "AN" },
            { name: "Atlántico Sur", code: "AS" },
            { name: "Boaco", code: "BO" },
            { name: "Carazo", code: "CA" },
            { name: "Chinandega", code: "CI" },
            { name: "Chontales", code: "CO" },
            { name: "Esteli", code: "ES" },
            { name: "Granada", code: "GR" },
            { name: "Jinotega", code: "JI" },
            { name: "León", code: "LE" },
            { name: "Madriz", code: "MD" },
            { name: "Managua", code: "MN" },
            { name: "Masaya", code: "MS" },
            { name: "Matagalpa", code: "MT" },
            { name: "Nueva Segovia", code: "NS" },
            { name: "Río San Juan", code: "SJ" },
            { name: "Rivas", code: "RI" },
        ],
        Panama: [
            { name: "Bocas del Toro", code: "Bocas del Toro" },
            { name: "Chiriqui", code: "Chiriqui" },
            { name: "Cocle", code: "Cocle" },
            { name: "Colón", code: "Colón" },
            { name: "Darien", code: "Darien" },
            { name: "Emberá", code: "Emberá" },
            { name: "Herrera", code: "Herrera" },
            { name: "Kuna Yala", code: "Kuna Yala" },
            { name: "Los Santos", code: "Los Santos" },
            { name: "Ngöbe-Buglé", code: "Ngöbe-Buglé" },
            { name: "Veraguas", code: "Veraguas" },
        ],
        Peru: [
            { name: "Amazonas", code: "AMA" },
            { name: "Ancash", code: "ANC" },
            { name: "Apurímac", code: "APU" },
            { name: "Arequipa", code: "ARE" },
            { name: "Ayacucho", code: "AYA" },
            { name: "Cajamarca", code: "CAJ" },
            { name: "Cusco", code: "CUS" },
            { name: "El Callao", code: "CAL" },
            { name: "Huancavelica", code: "HUV" },
            { name: "Huánuco", code: "HUC" },
            { name: "Ica", code: "ICA" },
            { name: "Junín", code: "JUN" },
            { name: "La Libertad", code: "LAL" },
            { name: "Lamayeque", code: "LAM" },
            { name: "Lima", code: "LIM" },
            { name: "Loreto", code: "LOR" },
            { name: "Madre de Dios", code: "MDD" },
            { name: "Moquegua", code: "MOQ" },
            { name: "Municipalidad Metropolitana de Lima", code: "LMA" },
            { name: "Pasco", code: "PAS" },
            { name: "Piura", code: "PIU" },
            { name: "Puno", code: "PUN" },
            { name: "San Martín", code: "SAM" },
            { name: "Tacna", code: "TAC" },
            { name: "Tumbes", code: "TUM" },
            { name: "Ucuyali", code: "UCA" },
        ],
        "El Salvador": [
            { name: "Ahuachapan", code: "AH" },
            { name: "Cabanas", code: "CA" },
            { name: "Chalatenango", code: "CH" },
            { name: "Cuscatlan", code: "CU" },
            { name: "La Libertad", code: "LI" },
            { name: "La Paz", code: "PA" },
            { name: "La Union", code: "UN" },
            { name: "Morazan", code: "MO" },
            { name: "San Miguel", code: "SM" },
            { name: "San Salvador", code: "SS" },
            { name: "San Vicente", code: "SV" },
            { name: "Santa Ana", code: "SA" },
            { name: "Sonsonate", code: "SO" },
            { name: "Usulutan", code: "US" },
        ],
        Uruguay: [
            { name: "Artigas", code: "AR" },
            { name: "Canelones", code: "CA" },
            { name: "Cerro Largo", code: "CL" },
            { name: "Colonia", code: "CO" },
            { name: "Durazno", code: "DU" },
            { name: "Flores", code: "FS" },
            { name: "Florida", code: "FD" },
            { name: "Lavalleja", code: "LA" },
            { name: "Maldonado", code: "MA" },
            { name: "Montevideo", code: "MO" },
            { name: "Paysandú", code: "PA" },
            { name: "Río Negro", code: "RN" },
            { name: "Rivera", code: "RV" },
            { name: "Rocha", code: "RO" },
            { name: "Salto", code: "SA" },
            { name: "San José", code: "SJ" },
            { name: "Soriano", code: "SO" },
            { name: "Tacuarembó", code: "TA" },
            { name: "Treinta y Tres", code: "TT" },
        ],
        Venezuela: [
            { name: "Amazonas", code: "Amazonas" },
            { name: "Anzoategui", code: "Anzoategui" },
            { name: "Apure", code: "Apure" },
            { name: "Aragua", code: "Aragua" },
            { name: "Barinas", code: "Barinas" },
            { name: "Bolívar", code: "Bolívar" },
            { name: "Carabobo", code: "Carabobo" },
            { name: "Cojedes", code: "Cojedes" },
            { name: "Delta Amacuro", code: "Delta Amacuro" },
            { name: "Dependencias Federales", code: "Dependencias Federales" },
            { name: "Distrito Federal", code: "Distrito Federal" },
            { name: "Falcón", code: "Falcón" },
            { name: "Guarico", code: "Guarico" },
            { name: "Lara", code: "Lara" },
            { name: "Mérida", code: "Mérida" },
            { name: "Mirinda", code: "Mirinda" },
            { name: "Monagas", code: "Monagas" },
            { name: "Nueva Esparta", code: "Nueva Esparta" },
            { name: "Portuguesa", code: "Portuguesa" },
            { name: "Sucre", code: "Sucre" },
            { name: "Tachira", code: "Tachira" },
            { name: "Trujillo", code: "Trujillo" },
            { name: "Vargas", code: "Vargas" },
            { name: "Yaracuy", code: "Yaracuy" },
            { name: "Zulia", code: "Zulia" },
        ],
        "South Korea": [
            { name: "Gangwon", code: "GW" },
            { name: "Gyeonggi", code: "GG" },
            { name: "Chungbuk", code: "CB" },
            { name: "Gyeongbuk", code: "GB" },
            { name: "Jeonbuk", code: "JB" },
            { name: "Chungnam", code: "CN" },
            { name: "Gyeongnam", code: "GN" },
            { name: "Jeonnam", code: "JN" },
            { name: "Seoul", code: "SL" },
        ],
    };

    regionNotRequiredCountries = ["Japan"];

    /**
     * Business Email Validation
     */
    isEmailTypoFree = (email) => {
        if (!email) return { isValid: true };

        // Check for personal email addresses and disallowed patterns
        const personalEmailPattern =
            /\.\.|\.@|@gmail\.|@yahoo\.|@outlook\.|@icloud\.|@me\.|@hotmail\./i;
        if (personalEmailPattern.test(email)) {
            return {
                isValid: false,
                message: "Personal email addresses are not allowed",
            };
        }

        // Combine all typo patterns (case-insensitive)
        const typoPatterns = [
            // Domain typos
            /\.(con|coom|ogr|ccom|ent|eud|ten)$/i,
            // Email service misspellings
            /(gmial\.com|hotmai\.com|gmaill\.com|gmai\.com|yaho\.com|gamail\.com)/i,
            // Rockwell domain typos
            /(!rockwel\.com|rockwellautomatoin\.com|rockwellautomaiton\.com|rarockwell\.com|rockwell\.co|rcokwell\.com|rockwelautomation\.com|rockkwell\.com|rockwrll\.com|rockwll\.com|rockwellautomtion\.com|rokcwell\.com|rockwel\.com|rocckwell\.com|cockwell\.com|rockwelll\.com|rockwellautotmation\.com|rockwellsutomation\.com|rockkwellautomation\.com|rockwellautomtion\.com|rockwellauotmtion\.com|rockwellautomatin\.com|rockell\.com|rockwellsautomation\.com|rockwellautmation\.com)/i,
        ];

        for (const pattern of typoPatterns) {
            if (pattern.test(email)) {
                return {
                    isValid: false,
                    message:
                        "We've detected a misspelling in your email address.",
                };
            }
        }
        return { isValid: true };
    };

    /**
     * Send Analytics View
     */
    sendAnalyticsView = () => {
        this.state.digitalData.push({
            event: "formView",
            formViewDetail: {
                formName: this.state.formName,
                formId: this.state.formId,
                formTitle: this.state.formTitle,
                formType: this.state.formType,
            },
        });
    };

    /**
     * Send Analytics Submit
     */
    sendAnalyticsSubmit = () => {
        this.state.digitalData.push({
            event: "formSubmit",
            formSubmitDetail: {
                formName: this.state.formName,
                formId: this.state.formId,
                formTitle: this.state.formTitle,
                formType: this.state.formType,
            },
        });
    };

    /**
     * Handle File Uploads and Submit the Form
     */
    handleFileUploadsAndSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(this.elements.form);

        if (this.elements.stateSelect) {
            formData.delete("stateProv");
            if (this.state.stateInputType === "select") {
                const stateSelect = this.elements.stateSelect.value;
                formData.append("stateProv", stateSelect);
            }
        }

        // Check for UTM parameters in query string
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("utm_campaign")) {
            formData.append("utm_campaign", urlParams.get("utm_campaign"));
        }
        if (urlParams.get("utm_creative")) {
            formData.append("utm_creative", urlParams.get("utm_creative"));
        }
        if (urlParams.get("utm_medium")) {
            formData.append("utm_medium", urlParams.get("utm_medium"));
        }
        if (urlParams.get("utm_placement")) {
            formData.append("utm_placement", urlParams.get("utm_placement"));
        }
        if (urlParams.get("utm_source")) {
            formData.append("utm_source", urlParams.get("utm_source"));
        }
        if (urlParams.get("utm_content")) {
            formData.append("utm_content", urlParams.get("utm_content"));
        }
        if (urlParams.get("utm_term")) {
            formData.append("utm_term", urlParams.get("utm_term"));
        }

        // Show Loader
        window.dispatchEvent(new CustomEvent("show-loading", null));

        // Convert FormData to URL-encoded format for Eloqua compatibility
        const urlEncodedData = new URLSearchParams();
        for (const [key, value] of formData.entries()) {
            urlEncodedData.append(key, value);
        }

        // Make AJAX Call
        try {
            const response = await fetch(this.state.formAction, {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/x-www-form-urlencoded; charset=UTF-8",
                },
                mode: "no-cors",
                body: urlEncodedData,
            });

            if (
                response &&
                (response.status === 200 || response.status === 0)
            ) {
                // Analytics
                this.sendAnalyticsSubmit();
                window.location.href =
                    this.state.redirectPage || window.location.href;
            } else {
                window.dispatchEvent(new CustomEvent("hide-loading", null));
            }
        } catch (error) {
            console.warn(error);
            window.dispatchEvent(new CustomEvent("hide-loading", null));
        }
    };

    /**
     * Handle Validation
     */
    handleValidation = (e) => {
        let hasError = false;
        const requiredFields = this.element.querySelectorAll(
            "input[data-required], textarea[data-required], select[data-required]",
        );

        [...requiredFields].forEach((fieldEle) => {
            if (
                fieldEle.disabled ||
                fieldEle
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.contains("hidden")
            ) {
                return;
            }
            const isText = fieldEle.classList.contains(
                `${this.state.theme}-input__input`,
            );
            const isCheckbox = fieldEle.classList.contains(
                `${this.state.theme}-checkbox__checkbox`,
            );
            const isSelect = fieldEle.classList.contains(
                `${this.state.theme}-select__select`,
            );

            // Text Fields
            if (isText) {
                const inputValue = fieldEle.value.trim();
                const isEmpty = inputValue === "";
                const parentContainerEle = fieldEle.closest(
                    `.${this.state.theme}-formfield`,
                );
                const errorMessage = parentContainerEle.querySelector(
                    `.${this.state.theme}-formfield__caption-error`,
                );

                let isInvalid = false;
                let customErrorMessage = null;

                // Check if field is empty first
                if (isEmpty) {
                    isInvalid = true;
                } else {
                    // Business email validation for email fields with specific attribute
                    if (
                        fieldEle.type === "email" &&
                        fieldEle.getAttribute(
                            "data-business-email-required",
                        ) === "true"
                    ) {
                        const emailValidation =
                            this.isEmailTypoFree(inputValue);
                        if (!emailValidation.isValid) {
                            isInvalid = true;
                            customErrorMessage = emailValidation.message;
                        }
                    }
                }

                if (isInvalid) {
                    hasError = true;
                    parentContainerEle.classList.add(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    fieldEle.classList.add(
                        `${this.state.theme}-input__input--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "false");
                        if (customErrorMessage) {
                            errorMessage.textContent = customErrorMessage;
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    fieldEle.classList.remove(
                        `${this.state.theme}-input__input--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "true");
                    }
                }
            }

            // Checkboxes
            if (isCheckbox) {
                const parentContainerEle = fieldEle.closest(
                    `.${this.state.theme}-formfield`,
                );
                const errorMessage = parentContainerEle.querySelector(
                    `.${this.state.theme}-formfield__caption-error`,
                );

                const isEmpty = !fieldEle.checked;

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    fieldEle.classList.add(
                        `${this.state.theme}-checkbox__checkbox--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "false");
                    }
                } else {
                    parentContainerEle.classList.remove(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    fieldEle.classList.remove(
                        `${this.state.theme}-checkbox__checkbox--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "true");
                    }
                }
            }

            // Selects
            if (isSelect) {
                const isEmpty = fieldEle.value === "";
                const parentContainerEle = fieldEle.closest(
                    `.${this.state.theme}-formfield`,
                );
                const errorMessage = parentContainerEle.querySelector(
                    `.${this.state.theme}-formfield__caption-error`,
                );

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    fieldEle.classList.add(
                        `${this.state.theme}-select__select--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "false");
                    }
                } else {
                    parentContainerEle.classList.remove(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    fieldEle.classList.remove(
                        `${this.state.theme}-select__select--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "true");
                    }
                }
            }
        });

        if (this.elements.submitButton) {
            this.elements.submitButton.blur();
        }

        if (hasError) {
            // Focus first invalid field - scroll to first error
            this.focusFirstInvalidField();
            return;
        }

        return this.handleFileUploadsAndSubmit(e);
    };

    /**
     * Focus first invalid field for accessibility and user experience
     */
    focusFirstInvalidField = () => {
        const requiredFields = this.element.querySelectorAll(
            "input[data-required], textarea[data-required], select[data-required]",
        );

        for (let i = 0; i < requiredFields.length; i++) {
            const field = requiredFields[i];
            const formfield = field.closest(`.${this.state.theme}-formfield`);

            // Skip hidden fields
            if (field.disabled || formfield.classList.contains("hidden")) {
                continue;
            }

            // Check if field has invalid state
            if (
                formfield.classList.contains(
                    `${this.state.theme}-formfield--invalid`,
                )
            ) {
                field.focus();
                break;
            }
        }
    };

    /**
     * Initialize Phone Number Combination
     * Concatenates country code and phone number into a single field
     */
    initPhoneCombination = () => {
        const countryCodeEl = this.element.querySelector(
            `#${this.state.theme}-country-code, [id$="${this.state.theme}-country-code"]`,
        );
        const telephoneEl = this.element.querySelector(
            `#${this.state.theme}-telephone, [id$="${this.state.theme}-telephone"]`,
        );

        // Find or create the combined phone input
        let phoneFullInput = this.element.querySelector(
            'input[name="businessPhone"], input[name="PhoneFull"]',
        );
        if (!phoneFullInput && (countryCodeEl || telephoneEl)) {
            phoneFullInput = document.createElement("input");
            phoneFullInput.type = "hidden";
            phoneFullInput.name = "businessPhone";
            phoneFullInput.id = "phoneFull";
            this.elements.form.appendChild(phoneFullInput);
        }

        if (!countryCodeEl || !telephoneEl || !phoneFullInput) return;

        const updateCombinedPhone = () => {
            // Get values and ensure they're strings
            const countryCode = (countryCodeEl.value || "").trim();
            const telephone = (telephoneEl.value || "").trim();

            // Update the combined field if we have both values
            if (countryCode && telephone) {
                phoneFullInput.value = countryCode + telephone;
            } else if (countryCode || telephone) {
                // If we only have one value, still update
                phoneFullInput.value = countryCode + telephone;
            } else {
                phoneFullInput.value = "";
            }

            // Dispatch a custom event to notify other parts of the code
            phoneFullInput.dispatchEvent(
                new Event("change", { bubbles: true }),
            );
        };

        // Add a small delay for initial update to ensure fields are populated
        setTimeout(() => {
            updateCombinedPhone();
        }, 100);

        // Update whenever either field changes - using multiple event types for better coverage
        const events = ["input", "change", "blur", "keyup"];

        events.forEach((eventType) => {
            countryCodeEl.addEventListener(eventType, updateCombinedPhone);
            telephoneEl.addEventListener(eventType, updateCombinedPhone);
        });

        // Also listen for when the country code might be programmatically updated
        const observer = new MutationObserver(() => {
            updateCombinedPhone();
        });

        observer.observe(countryCodeEl, {
            attributes: true,
            attributeFilter: ["value"],
            subtree: false,
        });
    };

    /**
     * Initialize Live Email Validation
     */
    initEmailValidation = () => {
        const emailFields = this.element.querySelectorAll(
            'input[type="email"][data-business-email-required="true"]',
        );

        emailFields.forEach((emailField) => {
            let hasBeenTouched = false;

            const validateEmail = () => {
                if (!hasBeenTouched) return;

                const inputValue = emailField.value.trim();
                const parentContainerEle = emailField.closest(
                    `.${this.state.theme}-formfield`,
                );
                const errorMessage = parentContainerEle.querySelector(
                    `.${this.state.theme}-formfield__caption-error`,
                );

                if (inputValue === "") {
                    // Clear validation state when empty (let required validation handle this)
                    parentContainerEle.classList.remove(
                        `${this.state.theme}-formfield--invalid`,
                    );
                    emailField.classList.remove(
                        `${this.state.theme}-input__input--invalid`,
                    );
                    if (errorMessage) {
                        errorMessage.setAttribute("aria-hidden", "true");
                    }
                } else {
                    const emailValidation = this.isEmailTypoFree(inputValue);
                    if (!emailValidation.isValid) {
                        parentContainerEle.classList.add(
                            `${this.state.theme}-formfield--invalid`,
                        );
                        emailField.classList.add(
                            `${this.state.theme}-input__input--invalid`,
                        );
                        if (errorMessage) {
                            errorMessage.setAttribute("aria-hidden", "false");
                            errorMessage.textContent = emailValidation.message;
                        }
                    } else {
                        parentContainerEle.classList.remove(
                            `${this.state.theme}-formfield--invalid`,
                        );
                        emailField.classList.remove(
                            `${this.state.theme}-input__input--invalid`,
                        );
                        if (errorMessage) {
                            errorMessage.setAttribute("aria-hidden", "true");
                        }
                    }
                }
            };

            // Mark as touched when user starts interacting
            emailField.addEventListener("focus", () => {
                hasBeenTouched = true;
            });

            // Validate on blur to avoid disrupting user while typing
            emailField.addEventListener("blur", validateEmail);
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.handleValidation(e);
    };

    handleCountryChange = () => {
        const selectedCountry = this.elements.countrySelect.value;
        const selectedCountryStates =
            this.countryToStatesMap[selectedCountry] || [];

        if (this.elements.stateSelect) {
            if (
                this.regionNotRequiredCountries.includes(selectedCountry) ||
                selectedCountryStates.length === 0
            ) {
                this.elements.stateSelect
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.add("hidden");
                this.state.stateInputType = "none";
            } else {
                this.elements.stateSelect
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.remove("hidden");
                this.state.stateInputType = "select";
                this.elements.stateSelect.innerHTML = "";
                const defaultOptionEle = document.createElement("option");
                defaultOptionEle.value = "";
                defaultOptionEle.text = "";
                defaultOptionEle.selected = true;
                this.elements.stateSelect.appendChild(defaultOptionEle);
                selectedCountryStates.forEach((state) => {
                    const optionEle = document.createElement("option");
                    optionEle.value = state.code;
                    optionEle.text = state.name;
                    this.elements.stateSelect.appendChild(optionEle);
                });
            }
        }

        if (selectedCountry === "Canada") {
            if (this.elements.canadiaOptIn) {
                this.elements.canadiaOptIn
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.remove("hidden");
                this.elements.canadiaOptIn.setAttribute(
                    "data-required",
                    "true",
                );
            }
        } else {
            if (this.elements.canadiaOptIn) {
                this.elements.canadiaOptIn
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.add("hidden");
                this.elements.canadiaOptIn.removeAttribute("data-required");
            }
        }
        if (this.euCountries.includes(selectedCountry)) {
            if (this.elements.gdprConsent) {
                this.elements.gdprConsent
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.remove("hidden");
                this.elements.gdprConsent.setAttribute("data-required", "true");
            }
        } else {
            if (this.elements.gdprConsent) {
                this.elements.gdprConsent
                    .closest(`.${this.state.theme}-formfield`)
                    .classList.add("hidden");
                this.elements.gdprConsent.removeAttribute("data-required");
            }
        }
    };

    /**
     * Add Checkbox Event Handlers
     */
    addCheckboxEventHandlers = () => {
        const checkboxes = this.element.querySelectorAll(
            'input[type="checkbox"]',
        );
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                const container = checkbox.closest(
                    `.${this.state.theme}-formfield`,
                );
                if (checkbox.checked) {
                    checkbox.classList.remove(
                        `${this.state.theme}-checkbox__checkbox--invalid`,
                    );
                    if (container)
                        container.classList.remove(
                            `${this.state.theme}-formfield--invalid`,
                        );
                }
            });
        });
    };

    /**
     * Add Live Validation Event Handlers
     * Clears error states when users start interacting with fields
     */
    addLiveValidationEventHandlers = () => {
        const requiredFields = this.element.querySelectorAll(
            "input[data-required], textarea[data-required], select[data-required]",
        );

        [...requiredFields].forEach((fieldEle) => {
            const isText = fieldEle.classList.contains(
                `${this.state.theme}-input__input`,
            );
            const isCheckbox = fieldEle.classList.contains(
                `${this.state.theme}-checkbox__checkbox`,
            );
            const isSelect = fieldEle.classList.contains(
                `${this.state.theme}-select__select`,
            );

            const validateField = () => {
                // Skip if field is disabled or hidden
                if (
                    fieldEle.disabled ||
                    fieldEle
                        .closest(`.${this.state.theme}-formfield`)
                        .classList.contains("hidden")
                ) {
                    return;
                }

                const parentContainerEle = fieldEle.closest(
                    `.${this.state.theme}-formfield`,
                );
                const errorMessage = parentContainerEle.querySelector(
                    `.${this.state.theme}-formfield__caption-error`,
                );

                let isValid = false;
                let customErrorMessage = null;

                // Text Fields (including email)
                if (isText) {
                    const inputValue = fieldEle.value.trim();
                    const isEmpty = inputValue === "";

                    if (!isEmpty) {
                        // Business email validation for email fields with specific attribute
                        if (
                            fieldEle.type === "email" &&
                            fieldEle.getAttribute(
                                "data-business-email-required",
                            ) === "true"
                        ) {
                            const emailValidation =
                                this.isEmailTypoFree(inputValue);
                            if (!emailValidation.isValid) {
                                isValid = false;
                                customErrorMessage = emailValidation.message;
                            } else {
                                isValid = true;
                            }
                        } else {
                            isValid = true;
                        }
                    }

                    if (isValid) {
                        parentContainerEle.classList.remove(
                            `${this.state.theme}-formfield--invalid`,
                        );
                        fieldEle.classList.remove(
                            `${this.state.theme}-input__input--invalid`,
                        );
                        if (errorMessage) {
                            errorMessage.setAttribute("aria-hidden", "true");
                        }
                    } else if (!isEmpty && customErrorMessage) {
                        // Only show custom error if field is not empty
                        parentContainerEle.classList.add(
                            `${this.state.theme}-formfield--invalid`,
                        );
                        fieldEle.classList.add(
                            `${this.state.theme}-input__input--invalid`,
                        );
                        if (errorMessage) {
                            errorMessage.setAttribute("aria-hidden", "false");
                            errorMessage.textContent = customErrorMessage;
                        }
                    }
                }

                // Checkboxes
                if (isCheckbox) {
                    if (fieldEle.checked) {
                        parentContainerEle.classList.remove(
                            `${this.state.theme}-formfield--invalid`,
                        );
                        fieldEle.classList.remove(
                            `${this.state.theme}-checkbox__checkbox--invalid`,
                        );
                        if (errorMessage) {
                            errorMessage.setAttribute("aria-hidden", "true");
                        }
                    }
                }

                // Selects
                if (isSelect) {
                    const isEmpty = fieldEle.value === "";

                    if (!isEmpty) {
                        parentContainerEle.classList.remove(
                            `${this.state.theme}-formfield--invalid`,
                        );
                        fieldEle.classList.remove(
                            `${this.state.theme}-select__select--invalid`,
                        );
                        if (errorMessage) {
                            errorMessage.setAttribute("aria-hidden", "true");
                        }
                    }
                }
            };

            // Add event listeners based on field type
            if (isText) {
                fieldEle.addEventListener("input", validateField);
                fieldEle.addEventListener("change", validateField);
                fieldEle.addEventListener("blur", validateField);
            } else if (isSelect) {
                fieldEle.addEventListener("change", validateField);
            } else if (isCheckbox) {
                fieldEle.addEventListener("change", validateField);
            }
        });
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.form.addEventListener("submit", this.handleSubmit);
        if (this.elements.countrySelect) {
            this.elements.countrySelect.addEventListener(
                "change",
                this.handleCountryChange,
            );
        }
        this.addCheckboxEventHandlers();
        this.addLiveValidationEventHandlers();
    };

    /**
     * Initialize Component
     */
    init() {
        this.sendAnalyticsView();
        this.addEventListeners();
        this.initPhoneCombination();
        this.initEmailValidation();

        // Set default values
        if (
            this.elements.countrySelect &&
            this.elements.countrySelect.querySelectorAll("option").length <= 1
        ) {
            this.elements.defaultCountryOptions
                .querySelectorAll("option")
                .forEach((option) => {
                    this.elements.countrySelect.appendChild(option);
                    // Remove automatic country selection - country should default to empty
                });
        }
        this.elements.defaultCountryOptions.remove();

        if (
            this.elements.helpSelect &&
            this.elements.helpSelect.querySelectorAll("option").length <= 1
        ) {
            this.elements.defaultHelpOptions
                .querySelectorAll("option")
                .forEach((option) => {
                    this.elements.helpSelect.appendChild(option);
                });
        }
        this.elements.defaultHelpOptions.remove();

        if (
            this.elements.industrySelect &&
            this.elements.industrySelect.querySelectorAll("option").length <= 1
        ) {
            this.elements.defaultIndustryOptions
                .querySelectorAll("option")
                .forEach((option) => {
                    this.elements.industrySelect.appendChild(option);
                });
        }
        this.elements.defaultIndustryOptions.remove();

        if (this.elements.stateSelect) {
            this.handleCountryChange();
        }
        this.elements.defaultHelpOptions.remove();
    }
}

registerComponent(`.${componentName}`, FormContainer);
